
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Parts extends Vue {
  @Prop({ type: String, required: true })
  public type!: 'left' | 'right' | 'none';

  private get stroke(): string {
    return '#ffffff';
  }
}
